export default __webpack_public_path__ + "static/media/partners-certik.180fbe36.png";